import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, ChakraLink} from '@chakra-ui/react'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as RouteLink} from 'react-router-dom'

import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import {ChevronRight} from '../icons'

const DrawerMenuItem = ({
    title,
    handleClick = noop,
    svg,
    url = null,
    isAbsolute = false,
    color = null,
}) => {
    if (url && url !== '') {
        return (
            <Box
                {...{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '1rem',
                    borderRadius: '4px',
                    backgroundColor: 'background.light',
                    textStyle: 'body-medium',
                    color: 'button.text.background.primary-pressed',
                    fontWeight: '600',
                }}
            >
                {isAbsolute ? (
                    <ChakraLink
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        color={color || 'text.default'}
                    >
                        {title}
                    </ChakraLink>
                ) : (
                    <Link as={RouteLink} to={url} color={color || 'text.default'}>
                        {title}
                    </Link>
                )}
                <ChevronRight color="button.text.icon-hover" />
            </Box>
        )
    }
    if (svg) {
        return (
            <Box
                {...{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '1rem',
                    borderRadius: '4px',
                    backgroundColor: 'background.light',
                    textStyle: 'body-medium',
                    color: 'button.text.background.primary-pressed',
                    fontWeight: '600',
                    gap: '16px',
                }}
                onClick={handleClick}
            >
                {svg}
                <Text>{title}</Text>
            </Box>
        )
    }
    return (
        <Box
            {...{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                borderRadius: '4px',
                backgroundColor: 'background.light',
                textStyle: 'body-medium',
                color: 'button.text.background.primary-pressed',
                fontWeight: '600',
            }}
            onClick={handleClick}
        >
            <Text>{title}</Text>
            <ChevronRight color="button.text.icon-hover" />
        </Box>
    )
}

DrawerMenuItem.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }),
    svg: PropTypes.element,
    isAbsolute: PropTypes.bool,
    isLink: PropTypes.bool,
    customTitleColor: PropTypes.string,
    handleClick: PropTypes.func,
    variant: PropTypes.oneOf(['default', 'filter', 'promo', 'secondary', 'simpleLink', 'variant']),
    color: PropTypes.string,
}

export {DrawerMenuItem}
